import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import { Link } from 'react-router-dom';

const ConsolidatedLotLotsCard = ({ className, lots }) => {
  return (
    <Fragment>
      <h3 className="f3 mt0">Lots ({lots.length})</h3>
      <Card className={className}>
        <table className="table mb0">
          <thead>
            <tr>
              <th className="bt-n bb-n table-header">Reference</th>
            </tr>
          </thead>
          <tbody>
            {lots.map(l => (
              <tr className="table-row" key={l.id}>
                <td>
                  <Link to={`/lots/${l.id}`}>
                    <strong>{l.reference}</strong>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </Fragment>
  );
};

export default ConsolidatedLotLotsCard;



// WEBPACK FOOTER //
// ./src/components/consolidatedLotLotsCard/consolidatedLotLotsCard.jsx